import { Spin } from 'antd';
import { LuArrowUpRight } from 'react-icons/lu';

type Props = {
    title: string;
    variant?: 'light' | 'primary';
    onClick?: () => void;
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xlg';
    isArrow?: boolean;
    loading?: boolean;
    disabled?: boolean;
};
const LinkButton: React.FC<Props> = ({ title, variant = '', onClick, size = 'md', isArrow, loading, disabled }) => {
    const sizeText = {
        xs: 'text-xs',
        sm: 'text-sm',
        md: 'text-base',
        lg: 'text-lg',
        xlg: 'text-2xl',
    };
    return (
        <button
            className={`flex items-center link_button ${sizeText[size]} ${variant} uppercase`}
            onClick={onClick}
            disabled={loading || disabled}
        >
            <div className=" w-full btn_text">{title}</div>
            {loading ? (
                <div className="w-7 flex justify-center">
                    <Spin />
                </div>
            ) : isArrow ? (
                <div className="btn_arrow-wp">
                    <LuArrowUpRight className="ml-1" size={'1.5rem'} color="#41D17E" />
                </div>
            ) : null}
            <div className="link_button_line top"></div>
            <div className="link_button_line bottom"></div>
            <div className="link_button_line left"></div>
            <div className="link_button_line right"></div>
        </button>
    );
};
export default LinkButton;
